import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { GlobalOverlayService } from '../ui/global-overlay.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const overlay = inject(GlobalOverlayService);

  if (await auth.restoreSession(true)) return true;

   if (auth.consumeSessionExpired()) {
    overlay.error('เซสชันหมดอายุ', 'กรุณาเข้าสู่ระบบใหม่เพื่อใช้งานต่อ');
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url },
  });
};
